import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ver-detalle-tasas',
  templateUrl: './ver-detalle-tasas.component.html',
})
export class VerDetalleTasasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
